import { render, staticRenderFns } from "./pgmxList.vue?vue&type=template&id=5a0a2407&scoped=true&"
import script from "./pgmxList.vue?vue&type=script&lang=js&"
export * from "./pgmxList.vue?vue&type=script&lang=js&"
import style0 from "./pgmxList.vue?vue&type=style&index=0&id=5a0a2407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a2407",
  null
  
)

export default component.exports